export default {
  "pl": {
    "announcement": {
      "actions": {
        "delete_announcement": "Usuń post z aktualnościami",
        "edit": "Edytuj",
        "new": "Nowy post",
        "save": "Zapisz",
        "submit": "Opublikuj"
      },
      "attributes": {
        "description": "Opis"
      },
      "labels": {
        "customers": "klienci",
        "for": "dla",
        "image_tab": "Obraz",
        "now": "Teraz",
        "partiallyShared": "{project_name} (częściowo udostępniony)",
        "start": "Początek",
        "unitsCount": "1 Unit | {count} Units",
        "video_tab": "Film",
        "youtube_video": "Adres URL filmu w serwisie YouTube"
      },
      "name": "Ogłoszenie",
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Już niedługo w twoim panelu głównym zaczną się pojawiać cykliczne aktualizacje dotyczące miejsca budowy.",
            "title": "Tu znajdziesz swoje aktualności!"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Powitaj klientów lub udostępnij nowe informacje na temat projektu.",
            "title": "Utwórz swój pierwszy post z aktualnościami"
          },
          "none": {
            "project_required": "Wybierz projekt",
            "subtitle": "Powitaj swoich klientów lub podziel się pierwszą informacją o dowolnym projekcie."
          },
          "paste_video_url": "Wklej tutaj odnośnik do filmu w serwisie YouTube"
        }
      },
      "toasts": {
        "create": "Opublikowano post z aktualnościami",
        "delete": "Usunięto post z aktualnościami",
        "invalid_video": "To nie jest poprawny odnośnik do filmu w serwisie YouTube",
        "update": "Zaktualizowano post z aktualnościami"
      },
      "validation": {
        "pleaseAddContent": "Dodaj obraz, film lub opis"
      }
    }
  }
}
